module.exports = __webpack_public_path__ + "img/pm3.ad2e0148.png";